import React, { useState, useEffect } from "react";
import { MessageCircle, X } from 'lucide-react';
import { PHONE, PHONE_NUMBER } from './constants';

const prompts = [
    { text: 'Have an inquiry? Message Us @quilatonlawoffice', href: 'https://www.facebook.com/quilatonlawoffice', external: true },
    { text: 'Need legal assistance? Message Us @quilatonlawoffice', href: 'https://www.facebook.com/quilatonlawoffice', external: true },
    { text: `Call ${PHONE_NUMBER}`, href: `tel:${PHONE}` },
    { text: 'Message Us on Facebook @quilatonlawoffice', href: 'https://www.facebook.com/quilatonlawoffice', external: true },
];

export default function FloatingMessenger() {
    const [showMessage, setShowMessage] = useState(false);
    const [hovered, setHovered] = useState(false);
    const [dismissed, setDismissed] = useState(false);
    const [promptIndex, setPromptIndex] = useState(0);

    useEffect(() => {
        const showPrompt = () => {
            setPromptIndex((current) => {
                const next = Math.floor(Math.random() * prompts.length);
                return prompts.length > 1 && next === current ? (next + 1) % prompts.length : next;
            });
            setShowMessage(true);
            setTimeout(() => setShowMessage(false), 9000);
        };

        const showTimer = setTimeout(showPrompt, 8000);
        const repeatTimer = setInterval(showPrompt, 50000);

        return () => {
            clearTimeout(showTimer);
            clearInterval(repeatTimer);
        };
    }, []);

    const prompt = prompts[promptIndex];

    return (
        <div className="fixed bottom-5 right-5 z-[60] flex items-center gap-3 sm:bottom-6 sm:right-6">
            <div className={`relative overflow-hidden rounded-2xl border border-zinc-600/90 bg-gradient-to-b from-zinc-800 to-zinc-950 py-3 pl-5 pr-10 text-sm tracking-[0.04em] text-zinc-100 shadow-2xl shadow-black/60 backdrop-blur transition-all duration-300 ${
                    (showMessage || hovered) && !dismissed
                    ? "translate-x-0 opacity-100" 
                    : "pointer-events-none translate-x-5 opacity-0"
                }`}
            >
                <a href={prompt.href} target={prompt.external ? '_blank' : undefined} rel={prompt.external ? 'noopener noreferrer' : undefined} className="transition hover:text-white">
                    {prompt.text}
                </a>
                <button onClick={() => setDismissed(true)} aria-label="Close message" className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-zinc-500 transition hover:text-white">
                    <X size={14} />
                </button>
            </div>

            {/* Messenger button */}
            <a
                href="https://www.facebook.com/quilatonlawoffice"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contact Us"
                className="group float-gently flex h-14 items-center justify-center gap-2 rounded-2xl border border-zinc-400/80 bg-gradient-to-b from-zinc-200 via-zinc-400 to-zinc-700 px-5 text-sm font-medium text-zinc-950 shadow-2xl shadow-black/60 transition duration-300 hover:-translate-y-1 hover:border-white hover:shadow-zinc-300/20"
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                <MessageCircle
                    size={27}
                    strokeWidth={1.8}
                    className="transition duration-300 group-hover:scale-110"
                />

                {/* Desktop only */}
                <span className="hidden md:inline">
                    Contact Us
                </span>
            </a>
        </div>
    );
}
